const KEY = "zubaide_admin_authed_v1";

// CRA: REACT_APP_..., Vite: VITE_...
const ADMIN_EMAIL =
    process.env.REACT_APP_ADMIN_EMAIL || process.env.VITE_ADMIN_EMAIL || "your@email.com";
const ADMIN_PASSWORD =
    process.env.REACT_APP_ADMIN_PASSWORD || process.env.VITE_ADMIN_PASSWORD || "your_password";

export function adminLogin(email, password) {
    console.log("ENV EMAIL:", process.env.REACT_APP_ADMIN_EMAIL);
    console.log("ENV PASSWORD:", process.env.REACT_APP_ADMIN_PASSWORD);

    const ok =
        String(email || "").trim().toLowerCase() === String(ADMIN_EMAIL).trim().toLowerCase() &&
        String(password || "") === String(ADMIN_PASSWORD);

    if (ok) localStorage.setItem(KEY, "1");
    return ok;
}

export function adminLogout() {
    localStorage.removeItem(KEY);
}

export function isAdminAuthed() {
    return localStorage.getItem(KEY) === "1";
}
